module.exports = __webpack_public_path__ + "img/cp-20.7083215f.png";